export default "__VITE_ASSET__BLgliLoY__"